import {v4} from "uuid";
import {nil} from "felles-ng2/typer/nullish";
import {erTomEllerNil} from "felles-ng2/støttefunksjoner/strenger";

export function nyUuid(){
    return v4();
}

export const uuidRegexpStreng = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';
export const uuidRegexp = new RegExp(`^${uuidRegexpStreng}$`, 'i');

export function erUuid(muligUuid:string|nil):boolean{
    if (erTomEllerNil(muligUuid)) return false;
    return muligUuid.match(uuidRegexp) != null;
}
